export default "__VITE_ASSET__7Z06ImZ___"